export default "__VITE_ASSET__VzCg2eoc__"